import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {CP_ITEM_WISE_REPORT, ORDER_MAX_MIN_PRICE,SELECTABLE_PRACTITIONER, GENERATE_INVOICE,GENERATE_PERFOMA_INVOICE, GENERATE_INVOICE_VIEW, GENERATE_PERFOMA_INVOICE_VIEW} from "../../../Config/ApiUrl-CP";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import SelectableStatusMixin from "../../../Helper/SelectableOptions/SelectableStatusMixin";
import {mapGetters} from "vuex";
import {formatDateToLocal, numberWithCurrencySymbol} from "../../../Helper/Helper";

export default {
    mixins: [DatatableHelperMixin, SelectableStatusMixin],
    data() {
        return {
            filterHtml : '',
            options: {
                name: this.$t('cp_item_wise_report'),
                url: null,
                showCount: true,
                showClearFilter: true,
                showHeader: true,
                numberWithCurrencySymbol,
                columns: [
                    {
                        title: this.$t('Sr No.'),
                        type: 'object',
                        key: 'sr_no',
                        modifier: (value) => value 
                    },
                    {
                        title: this.$t('Month Of Order'),
                        type: 'custom-html',
                        // sortable: true,
                        key: 'order',
                        modifier: value => value ? `<span>${formatDateToLocal(value.created_at,false,null,0,'MMM YYYY')}</span>` : ''
                    },
                    {
                        title: this.$t('Date of Order'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: value => value ? `<span>${formatDateToLocal(value.created_at)}</span>` : ''
                    },
                    {
                        title: this.$t('Order No.'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (value) => value.invoice_number ? `<a href="${urlGenerator('order/details/'+value.id)}" class="redirectTo">${value.invoice_number}</a>` :'-',
                    },
                    {
                        title: this.$t('branch'),
                        type: 'custom-html',
                        // sortable: true,
                        key: 'order',
                        modifier: value => value ? `<span>${value.branch_or_warehouse.name}</span>` : ''
                    },
                    {
                        title: this.$t('Practitioner'),
                        type: 'object',
                        // sortable: true,
                        key: 'order',
                        modifier: (order) => (order.created_by?.full_name)
                    },
                    {
                        title: this.$t('customer'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (row) => row.customer.full_name ? `<a href="${urlGenerator('customer/view/'+row.customer.id)}" class="redirectTo">${row.customer.full_name}</a>` :'-',
                    },
                    {
                        title: this.$t('Invoice No.'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (order,row) => order.invoice_gen_number ? `<a href="${urlGenerator(GENERATE_INVOICE_VIEW+row.order.id)}" class="redirectTo">${order.invoice_gen_number}</a>` :'-',
                    },
                    {
                        title: this.$t('Invoice Date'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: value => value ? `<span>${formatDateToLocal(value.invoice_gen_date)}</span>` : ''
                    },
                    {
                        title: this.$t('Proforma No.'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (order,row) => order.perfoma_gen_number ? `<a href="${urlGenerator(GENERATE_PERFOMA_INVOICE_VIEW+row.order.id)}" class="redirectTo">${order.perfoma_gen_number}</a>` :'-',
                    },
                    {
                        title: this.$t('Order amount'),
                        type: 'custom-html',
                        key: 'sub_total',
                        titleAlignment: 'right',
                        modifier: value => `<p class="text-right mb-0">${numberWithCurrencySymbol(value)}</p>`
                    },
                    {
                        title: this.$t('Order Type'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: value => (value.parent_orderid > 0)?'Mod':'New'
                    },
                    {
                        title: this.$t('Order Status'),
                        type: 'custom-html',
                        key: 'order',
                        isVisible: true,
                        modifier: (value) => {
                            return `<span class="badge badge-pill badge-${value.status.class}">${value.status.translated_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('Payment Status'),
                        type: 'custom-html',
                        key: 'order',
                        isVisible: true,
                        modifier: (value) => {
                            return `<span class="badge badge-pill badge-${value.payment_status.class}">${value.payment_status.translated_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('Balance Payment'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: value => `<p class="text-right mb-0">${numberWithCurrencySymbol(value.due_amount)}</p>`
                    },
                    {
                        title: this.$t('Item'),
                        type: 'custom-html',
                        key: 'variant',
                        modifier: value => value ? `<span>${value.name}</span>` : ''
                    },
                    {
                        title: this.$t('Item Order Status'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (value) => {
                            return `<span class="badge badge-pill badge-${value.status.class}">${value.status.translated_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('Item Delivery Status'),
                        type: 'custom-html',
                        key: 'delivery_status_id',
                        modifier: (value,row) => {
                            return `<span class="badge badge-pill badge-${row.delivery_status?.class}">${row.delivery_status?.translated_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('Sales Price'),
                        type: 'custom-html',
                        key: 'price',
                        modifier: value => value ? `<span>${numberWithCurrencySymbol(value)}</span>` : ''
                    },
                    {
                        title: this.$t('CP base Price'),
                        type: 'custom-html',
                        key: 'cpbaseprice',
                        modifier: value => value ? `<span>${numberWithCurrencySymbol(value)}</span>` : ''
                    },
                    {
                        title: this.$t('CP GST'),
                        type: 'custom-html',
                        key: 'cpgst',
                        modifier: value => value ? `<span>${numberWithCurrencySymbol(value)}</span>` : ''

                    },
                    {
                        title: this.$t('CP Total'),
                        type: 'custom-html',
                        key: 'cptotal',
                        modifier: value => value ? `<span>${numberWithCurrencySymbol(value)}</span>` : ''
                    },
                    {
                        title: this.$t('Branch/Workshop'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (items,row) => {
                            let htmlString = '<p class="">Branch</p>';
                            if(this.shouldDisplayCustomOrders(row)) {
                                if (row.stock_deduction_type === 2) {
                                    htmlString = '<p class="">Workshop</p>';
                                }
                            }
                            return htmlString;
                        }
                    },
                    {
                        title: this.$t('CP Invoice No.'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: value => value.cp_invoice_no ? `<span>${value.cp_invoice_no}</span>` : ''
                    },
                    {
                        title: this.$t('CP Payment Status'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: (value) => {
                            return value.cp_payment_status ? `<span class="badge badge-pill badge-${value.cp_payment_status.class}">${value.cp_payment_status.translated_name}</span>`:'';
                        }
                    },
                    {
                        title: this.$t('CP Payment Notes'),
                        type: 'custom-html',
                        key: 'order',
                        modifier: value => value.cp_payment_note ? `<span>${value.cp_payment_note}</span>` : ''
                    },
                ],
                actionType: "dropdown",
                actions: [],
                filters: [
                    // {
                    //     title: this.$t('issue_date'),
                    //     type: "range-picker",
                    //     key: "date",
                    //     option: ["today", "thisMonth", "thisWeek", "lastMonth", "last7Days", "thisYear", "lastYear"]
                    // },
                    // {
                    //     title: "Practitioner",
                    //     type: "multi-select-filter",
                    //     key: "practitioners",
                    //     option: [],
                    // },
                    // {
                    //     title: this.$t('customer'),
                    //     type: 'search-and-select-filter',
                    //     key: 'customers',
                    //     settings: {
                    //         url: urlGenerator('app/selectable-customers'),
                    //         modifire: ({id, full_name}) => ({id, full_name}),
                    //         params: {},
                    //         per_page: 10,
                    //         queryName: 'search',
                    //         loader: 'app-pre-loader'
                    //     },
                    //     listValueField: 'full_name'
                    // },
                    // {
                    //     title: "Price Range",
                    //     type: "range-filter",
                    //     key: "range_filter",
                    //     maxTitle: "Max usd",
                    //     minTitle: "Min usd",
                    //     sign: "₹",
                    //     minRange: 0,
                    //     maxRange: 0,
                    // },
                    // {
                    //     title: "Order Status",
                    //     type: "multi-select-filter",
                    //     key: "order_status_ids",
                    //     option: [],
                    //     listValueField: 'name'
                    // },
                    // {
                    //     title: "Payment Status",
                    //     type: "multi-select-filter",
                    //     key: "payment_status",
                    //     option: [],
                    //     listValueField: 'name'
                    // },
                    // {
                    //     title: this.$t('Referral'),
                    //     type: 'checkbox',
                    //     key: 'referral',
                    //     option: [
                    //         { id: 'NA', value: this.$t('NA') },
                    //         { id: 'Yes', value: this.$t('Yes') },
                    //         { id: 'No', value: this.$t('No') },
                    //     ],
                    // },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                search: true,
            },
            orderMaxMinPriceUrl: ORDER_MAX_MIN_PRICE
        }
    },
    methods: {
        shouldDisplayCustomOrders(item) {
            const allowedCategoryIds = [1, 2, 3, 4, 5];
            return item.variant.product.main_category == 3 && allowedCategoryIds.includes(item.variant.product.category_id);
        },
        getMaxMinOrderPrice() {
            axiosGet(this.orderMaxMinPriceUrl).then((res) => {
                this.options?.filters.find(({key}) => {
                    if (key === 'range_filter') {
                        Object.assign(this.options.filters[3], res.data)
                    }
                })
            })
        },
        getInvoiceIdFilter() {
            this.options.filters.push({
                title: this.$t('invoice_id'),
                type: 'search-and-select-filter',
                key: 'invoice_number',
                settings: {
                    url: urlGenerator('app/selectable-invoice'),
                    modifire: ({id, invoice_number: value}) => ({id, value}),
                    params: {
                        branch_or_warehouse_id: this.getBranchOrWarehouseId,
                    },
                    per_page: 10,
                    queryName: 'search',
                    loader: 'app-pre-loader'
                }
            })
        },
        updateMinMaxPriceUrl() {
            this.orderMaxMinPriceUrl = `${ORDER_MAX_MIN_PRICE}?branch_or_warehouse_id=${this.getBranchOrWarehouseId}`
        },
        practitionerList() {
            axiosGet(SELECTABLE_PRACTITIONER).then((response) => {
                let name = this.options.filters.find(element => element.key === 'practitioners');
                if (name) name.option = response.data.data.map(name => {
                    return {
                        id: name.id,
                        value: name.full_name
                    }
                });
            }).catch((error) => {
                this.$toastr.e(error);
            });
        },
        getOrderStatus() {
            axiosGet("app/selectable-statuses?type=orderStatus").then((response) => {
                let name = this.options.filters.find(element => element.key === 'order_status_ids');
                if (name) name.option = response.data.data.map(name => {
                    return {
                        id: name.id,
                        name: name.translated_name
                    }
                });
            }).catch((error) => {
                this.$toastr.e(error);
            });
        },
        getPaymentStatus() {
            axiosGet("app/selectable-statuses?type=paymentStatus").then((response) => {
                let name = this.options.filters.find(element => element.key === 'payment_status');
                if (name) name.option = response.data.data.map(name => {
                    return {
                        id: name.id,
                        name: name.translated_name
                    }
                });
            }).catch((error) => {
                this.$toastr.e(error);
            });
        },
        
    },
    computed: {
        ...mapGetters(['getBranchOrWarehouseId']),
    },
    mounted() {
        this.updateUrl(CP_ITEM_WISE_REPORT, this.updateMinMaxPriceUrl);
        // this.getInvoiceIdFilter();
        this.getMaxMinOrderPrice();
        $(document).on('click','.redirectTo',function(){
            window.open($(this).attr('href'),'_blank');
        });
        const prac = axiosGet(SELECTABLE_PRACTITIONER).then((response) => {
            return response.data.data.map(name => {
                return {
                    id: name.id,
                    value: name.full_name
                }
            });
        }).catch((error) => {
            this.$toastr.e(error);
        });
        const orderStatusArr  = axiosGet("app/selectable-statuses?type=orderStatus").then((response) => {
            return response.data.data.map(name => {
                return {
                    id: name.id,
                    value: name.translated_name
                }
            });
        }).catch((error) => {
            this.$toastr.e(error);
        });
        const paymentStatusArr  = axiosGet("app/selectable-statuses?type=paymentStatus").then((response) => {
            return response.data.data.map(name => {
                return {
                    id: name.id,
                    value: name.translated_name
                }
            });
        }).catch((error) => {
            this.$toastr.e(error);
        });
        this.$hub.$on('filter-change', (newFilterValues) => {
            let filterData = Object.fromEntries(Object.entries(newFilterValues).filter(([_, v]) => v !== ''));
            this.filterHtml = '';
            if(filterData?.date?.start) {
                this.filterHtml = '<span class="d-block">Sales Report from '+formatDateToLocal(filterData?.date.start,false,null,0,'DD MMM YYYY')+' to '+formatDateToLocal(filterData?.date.end,false,null,0,'DD MMM YYYY')+'</span>';
            }
            if(filterData?.practitioners) {
                prac.then((resp) => {
                    let practArr = filterData?.practitioners.split(',');
                    var transformedArray = practArr.map(id => {
                        var option = resp.find((opt) => {
                            if(opt.id == id) return opt;
                        });
                        return option ? option.value : undefined;
                    });
                    this.filterHtml += '<span class="d-block">Practitioner : '+transformedArray.join(',')+'</span>';
                });
            }
            if(filterData?.customers) {
                axiosGet('app/selectable-customers?selected='+filterData?.customers).then((response) => {
                    const customerArr = response.data.data.map(name => {
                        return {
                            id: name.id,
                            value: name.full_name
                        }
                    });
                    this.filterHtml += '<span class="d-block">Patient : '+customerArr[0].value+'</span>';
                }).catch((error) => {
                    this.$toastr.e(error);
                });
            }
            if(filterData?.range_filter) {
                this.filterHtml += '<span class="d-block">Price Range From '+numberWithCurrencySymbol(filterData?.range_filter?.min)+' To '+numberWithCurrencySymbol(filterData?.range_filter?.max)+'</span>';
            }
            if(filterData?.order_status_ids) {
                orderStatusArr.then((resp) => {
                    let practArr = filterData?.order_status_ids.split(',');
                    var transformedArray = practArr.map(id => {
                        var option = resp.find((opt) => {
                            if(opt.id == id) return opt;
                        });
                        return option ? option.value : undefined;
                    });
                    this.filterHtml += '<span class="d-block">Order Status : '+transformedArray.join(',')+'</span>';
                });
            }
            if(filterData?.payment_status) {
                paymentStatusArr.then((resp) => {
                    let practArr = filterData?.payment_status.split(',');
                    var transformedArray = practArr.map(id => {
                        var option = resp.find((opt) => {
                            if(opt.id == id) return opt;
                        });
                        return option ? option.value : undefined;
                    });
                    this.filterHtml += '<span class="d-block">Payment Status : '+transformedArray.join(',')+'</span>';
                });
            }
        });
    },
    watch: {
        getBranchOrWarehouseId(new_id) {
            this.updateUrl(CP_ITEM_WISE_REPORT, this.updateMinMaxPriceUrl);
            this.$hub.$emit(`reload-${this.table_id}`)
        },
    },
    created() {
        this.updateMinMaxPriceUrl();
        this.practitionerList();
        this.getOrderStatus();
        this.getPaymentStatus();
    }
}